import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
// import {
// closeSnackbar,
// setEnabledGlobalLoading,
// } from "redux/slices/common/commonSlice";
import { SpakleIcon } from "assets/icons/SpakleIcon";

const SnackbarWrapper = styled.div`
  position: fixed;
  top: 62px;
  left: 50%;
  transform: translateX(-50%);

  background-color: #ffffff;
  border: 2px solid #00bb80;
  box-shadow: 4px 4px 20px 0px #22315a33;
  padding: 0 12px 0 16px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100vw - 32px);
  max-width: 520px;
  height: 54px;
  z-index: 1000;

  & > .snackbar-message {
    display: flex;
    align-items: center;
    color: #202020;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.2px;

    & > strong {
      color: #00ac78;
    }

    & > .snackbar-icon {
      margin-right: 2px;
    }
  }
`;

const ActionButton = styled.button`
  border: none;
  color: #ffffff;
  background: #00bb80;
  margin-left: 20px;
  cursor: pointer;
  min-width: 55px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border-radius: 8px;

  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.2px;
`;

const getMessageNode = (key) => {
  switch (key) {
    case "webviewChanged":
      return (
        <span className="snackbar-message">
          <span className="snackbar-icon">
            <SpakleIcon />
          </span>
          <strong>새로운 개선사항</strong>이 있어요!
        </span>
      );
    default:
      return key; // 기본적으로는 키 자체를 문자열로 표시
  }
};

const GlobalSnackbar = () => {
  // const dispatch = useDispatch();
  const { isOpen, messageKey, actionLabel } = useSelector(
    (state) => state.common.snackbar
  );

  if (!isOpen) return null;

  const handleAction = () => {
    // if (onAction) {
    //   onAction();
    // }
    // TODO: 추후 다시 작성
    // dispatch(setEnabledGlobalLoading(true));
    window.location.reload();
    // dispatch(closeSnackbar());
  };

  return (
    <SnackbarWrapper>
      {getMessageNode(messageKey)}
      {actionLabel && (
        <ActionButton onClick={handleAction}>{actionLabel}</ActionButton>
      )}
    </SnackbarWrapper>
  );
};

export default GlobalSnackbar;
